import "./App.css";
import { Provider } from "react-redux";
import { store } from "@Store/Store/store.js";
import RootRoutes from "./Routes/rootRoutes";
import "./Utils/chartConfig.js";

function App() {
  return (
    <Provider store={store}>
      <RootRoutes />
    </Provider>
  );
}

export default App;
